import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import Responsive from "../../modules/Responsive";
import Popover from "../../modules/Popover";
import Expandable from "../../modules/Expandable";
import Image from "../../elements/Image";
import { default as Button, ButtonColor, ButtonSizes, ButtonKind } from "../../elements/Button";
import { Direction } from "../../modules/Popover/components/Popover/PopoverTypes";
import Item from "./components/Item";
import CrossIcon from "@dcl/icons/esm/ui/cross";

var AnnotatedScreenshot = /*#__PURE__*/function (_React$Component) {
  _inherits(AnnotatedScreenshot, _React$Component);

  var _super = _createSuper(AnnotatedScreenshot);

  function AnnotatedScreenshot(props) {
    var _this;

    _classCallCheck(this, AnnotatedScreenshot);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(AnnotatedScreenshot.displayName));

    _defineProperty(_assertThisInitialized(_this), "popoverWrapperRefs", []);

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeId: 1,
      items: [],
      init: true
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      /*
        In the case of mobile, no action is needed here since expandables are used
        to show the content instead of the popover. So in mobile no Refs are set
       */
      if (_this.popoverWrapperRefs.length === 0) {
        return;
      }
      /*
        When the target(popover trigger/button) is clicked, its onChange handler is fired, changing state
        and causing a rerender. This means the event.target is no longer contained inside the DOM body, and therfor
        we know that trigger was clicked, so its not a click 'outside' and no action is taken,
       */


      if (document.body.contains(e.target)) {
        _this.setState({
          activeId: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === "Escape") {
        _this.setState({
          init: false,
          activeId: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (id) {
      _this.setState(function (prev) {
        return {
          // if it is a different id, assign, otherwise set to null to close
          activeId: id === prev.activeId ? null : id
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getButton", function (buttonLabel) {
      return /*#__PURE__*/React.createElement(Button, {
        color: ButtonColor.PRIMARY,
        kind: ButtonKind.LINK,
        href: "#_",
        iconOnly: true,
        shape: "circular",
        size: ButtonSizes.SMALL
      }, buttonLabel);
    });

    _defineProperty(_assertThisInitialized(_this), "getTrigger", function (id) {
      return _this.state.activeId === id ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Responsive, {
        minWidth: 769,
        maxWidth: 9001
      }, /*#__PURE__*/React.createElement(Button, {
        color: ButtonColor.PRIMARY,
        kind: ButtonKind.LINK,
        href: "#_",
        icon: true && /*#__PURE__*/React.createElement(CrossIcon, null),
        iconOnly: true,
        shape: "circular",
        size: ButtonSizes.SMALL
      }, "Button")), /*#__PURE__*/React.createElement(Responsive, {
        minWidth: 0,
        maxWidth: 768
      }, _this.getButton(id))) : /*#__PURE__*/React.createElement(React.Fragment, null, _this.getButton(id));
    });

    _defineProperty(_assertThisInitialized(_this), "getOpenDirectionModifiers", function (openDirection) {
      var modifiers = {
        flip: {
          enabled: false
        },
        offset: {
          offset: "50%, -50%"
        },
        openDirection: "bottom-start"
      };

      switch (openDirection) {
        case "topRight":
          modifiers = {
            flip: {
              enabled: false
            },
            offset: {
              offset: "50%, -50%"
            },
            openDirection: Direction.TOP_START
          };
          break;

        case "bottomRight":
          modifiers = {
            flip: {
              enabled: false
            },
            offset: {
              offset: "50%, -50%"
            },
            openDirection: Direction.BOTTOM_START
          };
          break;

        case "topLeft":
          modifiers = {
            flip: {
              enabled: false
            },
            offset: {
              offset: "-50%, -50%"
            },
            openDirection: Direction.TOP_END
          };
          break;

        case "bottomLeft":
          modifiers = {
            flip: {
              enabled: false
            },
            offset: {
              offset: "-50%, -50%"
            },
            openDirection: Direction.BOTTOM_END
          };
          break;

        default:
          break;
      }

      return modifiers;
    });

    _this.setPopoverWrapperRef = _this.setPopoverWrapperRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AnnotatedScreenshot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        init: false,
        activeId: 1
      });
      window.addEventListener("keydown", this.handleKeyDown);
      window.addEventListener("click", this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "setPopoverWrapperRef",
    value: function setPopoverWrapperRef(ref) {
      this.popoverWrapperRefs.push(ref);
    } //

  }, {
    key: "renderPopovers",
    value: function renderPopovers(items) {
      var _this2 = this;

      return items.map(function (_ref) {
        var x = _ref.x,
            y = _ref.y,
            itemNumber = _ref.itemNumber,
            openDirection = _ref.openDirection,
            header = _ref.header,
            content = _ref.content;

        var modifiers = _this2.getOpenDirectionModifiers(openDirection);

        var ONE_HUNDRED_PERCENT = 100;
        return /*#__PURE__*/React.createElement(Item, {
          className: _this2.getClassName({
            descendantName: "popoversItem"
          }),
          x: x,
          y: y,
          itemNumber: itemNumber,
          openDirection: openDirection,
          style: {
            position: "absolute",
            top: "".concat(x * ONE_HUNDRED_PERCENT, "%"),
            left: "".concat(y * ONE_HUNDRED_PERCENT, "%"),
            transform: "translate(-50%, -50%)"
          },
          key: itemNumber
        }, _this2.state.init || _this2.state.activeId === itemNumber ? /*#__PURE__*/React.createElement(Responsive, {
          minWidth: 0,
          maxWidth: 768
        }, /*#__PURE__*/React.createElement(Popover, {
          id: itemNumber,
          openDirection: modifiers.openDirection,
          modifiers: modifiers,
          active: false,
          onChange: function onChange() {},
          trigger: _this2.getTrigger(itemNumber)
        }, /*#__PURE__*/React.createElement("span", {
          className: _this2.getClassName({
            descendantName: "children"
          })
        }, header, content))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Responsive, {
          minWidth: 769,
          maxWidth: 9001
        }, /*#__PURE__*/React.createElement("div", {
          ref: _this2.setPopoverWrapperRef
        }, /*#__PURE__*/React.createElement(Popover, {
          id: itemNumber,
          openDirection: modifiers.openDirection,
          modifiers: modifiers,
          active: _this2.state.activeId === itemNumber,
          onChange: _this2.handleOnChange,
          trigger: _this2.getTrigger(itemNumber)
        }, /*#__PURE__*/React.createElement("span", {
          className: _this2.getClassName({
            descendantName: "children"
          })
        }, header, content)))));
      });
    }
  }, {
    key: "renderExpandables",
    value: function renderExpandables(items) {
      var _this3 = this;

      return items.map(function (_ref2) {
        var itemNumber = _ref2.itemNumber,
            _header = _ref2.header,
            content = _ref2.content;
        return /*#__PURE__*/React.createElement(Expandable.Item, {
          id: itemNumber,
          key: itemNumber,
          isExpanded: _this3.state.activeId === itemNumber,
          onChange: _this3.handleOnChange,
          className: "AnnotatedExpandable",
          header: function header(props) {
            return /*#__PURE__*/React.createElement(Expandable.Item.Header, props, /*#__PURE__*/React.createElement("div", {
              style: {
                display: "flex",
                fontWeight: "bold"
              }
            }, itemNumber, ".", "\xA0", _header));
          }
        }, content);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var items = this.state.items;
      var _this$props = this.props,
          alt = _this$props.alt,
          src = _this$props.src,
          srcSet = _this$props.srcSet,
          sizes = _this$props.sizes,
          height = _this$props.height,
          overlay = _this$props.overlay;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "aria-label": "Annotated Screenshot",
        "data-rehydratable": getRehydratableName(AnnotatedScreenshot.displayName),
        "data-alt": alt,
        "data-src": src,
        "data-srcset": srcSet,
        "data-sizes": sizes,
        "data-height": height,
        "data-overlay": overlay
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "popoverWrap"
        })
      }, /*#__PURE__*/React.createElement(Image, {
        alt: alt,
        sizes: sizes,
        src: src,
        srcSet: srcSet,
        height: height,
        overlay: overlay
      }), this.renderPopovers(items)), /*#__PURE__*/React.createElement(Responsive, {
        minWidth: 0,
        maxWidth: 768
      }, /*#__PURE__*/React.createElement("div", {
        title: "Annotations",
        "aria-label": "List of annotations and their content",
        className: this.getClassName({
          descendantName: "expandableWrap"
        })
      }, /*#__PURE__*/React.createElement(Expandable.List, null, this.renderExpandables(items)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var items = AnnotatedScreenshot.getAnnotatedItems(props.children);
      return _objectSpread(_objectSpread({}, state), {}, {
        items: items
      });
    }
  }, {
    key: "getAnnotatedItems",
    value: function getAnnotatedItems(children) {
      return React.Children.toArray(children).reduce(function (acc, child) {
        var type = child.type,
            props = child.props;

        if (type === Item) {
          var innerChildren = props.children,
              rest = _objectWithoutProperties(props, ["children"]);

          var _AnnotatedScreenshot$ = AnnotatedScreenshot.getAnnottatedItemHeaderAndContent(innerChildren),
              header = _AnnotatedScreenshot$.header,
              content = _AnnotatedScreenshot$.content;

          acc.push(_objectSpread(_objectSpread({}, rest), {}, {
            header: header,
            content: content
          }));
          return acc;
        }

        if (type !== Item && React.Children.count(props.children)) {
          return AnnotatedScreenshot.getAnnotatedItems(props.children);
        }

        return acc;
      }, []);
    }
  }, {
    key: "getAnnottatedItemHeaderAndContent",
    value: function getAnnottatedItemHeaderAndContent(children) {
      var initValue = {};
      return React.Children.toArray(children).reduce(function (acc, child) {
        var type = child.type,
            props = child.props;
        var innerChildren = props.children;
        var isHeader = type === Item.Header;
        var isContent = type === Item.Content;

        if (isHeader) {
          acc.header = child;
          return acc;
        } else if (isContent) {
          acc.content = child;
          return acc;
        }

        if (!isHeader && !isContent && !React.Children.only(child)) {
          return AnnotatedScreenshot.getAnnottatedItemHeaderAndContent(innerChildren);
        }

        return acc;
      }, initValue);
    }
  }]);

  return AnnotatedScreenshot;
}(React.Component);

_defineProperty(AnnotatedScreenshot, "displayName", "AnnotatedScreenshot");

_defineProperty(AnnotatedScreenshot, "Item", void 0);

AnnotatedScreenshot.Item = Item;
export default AnnotatedScreenshot;